var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM17.2691 9.53388C17.636 9.1211 17.5989 8.48903 17.1861 8.12211C16.7733 7.75519 16.1412 7.79237 15.7743 8.20515L10.8398 13.7564L8.10294 11.5669C7.67168 11.2219 7.04239 11.2918 6.69738 11.7231C6.35237 12.1543 6.42229 12.7836 6.85355 13.1286L10.3263 15.9068C10.5308 16.0731 10.7831 16.1456 11.0292 16.1277C11.1805 16.1167 11.3295 16.0715 11.4634 15.9927C11.5533 15.9399 11.6361 15.8722 11.7082 15.79L17.2691 9.53388Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidCheckCircle);
export default __webpack_public_path__ + "static/media/solid-check-circle.d345df35a7fe81a50a5c3c7707e81555.svg";
export { ForwardRef as ReactComponent };